// import { useEffect, useMemo, useState } from "react";
// import { Link } from "react-router-dom";
// import { db } from "../../firebase";
// import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
// import { toast } from "react-hot-toast";

// /* ───────── helpers ───────── */
// const normalizeDigits = (v = "") => (v || "").replace(/\D/g, "");

// const COUNTRY_DISTRICTS = {
//   "Sri Lanka": [
//     "Colombo",
//     "Gampaha",
//     "Kalutara",
//     "Kandy",
//     "Matale",
//     "Nuwara Eliya",
//     "Galle",
//     "Matara",
//     "Hambantota",
//     "Jaffna",
//     "Kilinochchi",
//     "Mannar",
//     "Vavuniya",
//     "Mullaitivu",
//     "Batticaloa",
//     "Ampara",
//     "Trincomalee",
//     "Kurunegala",
//     "Puttalam",
//     "Anuradhapura",
//     "Polonnaruwa",
//     "Badulla",
//     "Monaragala",
//     "Ratnapura",
//     "Kegalle",
//   ],
//   India: [
//     "Andhra Pradesh",
//     "Delhi",
//     "Gujarat",
//     "Karnataka",
//     "Kerala",
//     "Maharashtra",
//     "Punjab",
//     "Rajasthan",
//     "Tamil Nadu",
//     "Telangana",
//     "Uttar Pradesh",
//     "West Bengal",
//   ],
//   "United Arab Emirates": [
//     "Abu Dhabi",
//     "Dubai",
//     "Sharjah",
//     "Ajman",
//     "Umm Al Quwain",
//     "Ras Al Khaimah",
//     "Fujairah",
//   ],
//   "United Kingdom": ["England", "Scotland", "Wales", "Northern Ireland"],
//   "United States": [
//     "Alabama",
//     "California",
//     "Florida",
//     "New York",
//     "Texas",
//     "Washington",
//   ],
// };

// const COUNTRY_OPTIONS = Object.keys(COUNTRY_DISTRICTS);

// /* ───────── component ───────── */
// export default function AgentApply({ user }) {
//   const [form, setForm] = useState({
//     fullName: "",
//     phone: "",
//     country: "",
//     district: "",
//     city: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [existing, setExisting] = useState(null);

//   // districts for selected country
//   const districts = useMemo(() => {
//     if (!form.country) return [];
//     return COUNTRY_DISTRICTS[form.country] || [];
//   }, [form.country]);

//   // prefill if agent doc exists
//   useEffect(() => {
//     (async () => {
//       if (!user?.uid) return;
//       const snap = await getDoc(doc(db, "agents", user.uid));
//       if (snap.exists()) {
//         const d = snap.data();
//         setExisting({ id: snap.id, ...d });
//         setForm((f) => ({
//           ...f,
//           fullName: d.fullName || f.fullName,
//           phone: d.phone || d.mobile || f.phone,
//           country: d.country || f.country,
//           district: d.district || f.district,
//           city: d.city || d.town || f.city,
//         }));
//       }
//     })();
//   }, [user?.uid]);

//   const onChange = (k) => (e) => {
//     const val = e.target.value;
//     setForm((s) => {
//       // when country changes, clear district
//       if (k === "country") return { ...s, country: val, district: "" };
//       return { ...s, [k]: val };
//     });
//   };

//   const save = async () => {
//     if (!user?.uid) {
//       toast.error("Please login first");
//       return;
//     }
//     const fullName = form.fullName.trim();
//     const phoneDigits = normalizeDigits(form.phone);
//     const country = form.country.trim();
//     const district = form.district.trim();
//     const city = form.city.trim();

//     if (!fullName || !phoneDigits || !country || !district || !city) {
//       toast.error("Please fill all fields");
//       return;
//     }
//     if (phoneDigits.length < 7) {
//       toast.error("Enter a valid phone number (min 7 digits)");
//       return;
//     }

//     try {
//       setLoading(true);
//       await setDoc(
//         doc(db, "agents", user.uid),
//         {
//           fullName,
//           phone: form.phone, // keep original formatting
//           mobile: phoneDigits, // normalized for lookups
//           country,
//           district,
//           city, // store town/city as `city`
//           status: existing?.status || "pending",
//           cardFeePerCardUSD: existing?.cardFeePerCardUSD ?? 1,
//           feeOutstandingUSD: existing?.feeOutstandingUSD ?? 0,
//           feePendingUSD: existing?.feePendingUSD ?? 0,
//           createdAt: existing?.createdAt || serverTimestamp(),
//           updatedAt: serverTimestamp(),
//           // optional helpful mirrors
//           username:
//             existing?.username ||
//             user.displayName ||
//             user.email ||
//             user.uid.slice(0, 6),
//           email: existing?.email || user.email || "",
//           avatar: existing?.avatar || user.photoURL || "/user.png",
//         },
//         { merge: true }
//       );
//       toast.success("Application saved");
//     } catch (e) {
//       console.error(e);
//       toast.error("Failed to save");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ───────── UI ───────── */
//   if (!user?.uid) {
//     return (
//       <div className="max-w-xl mx-auto mt-10 bg-slate-800 p-6 rounded-2xl text-center">
//         <h1 className="text-2xl font-bold mb-2">Apply as Agent</h1>
//         <p className="text-slate-300 mb-4">
//           You need to be signed in before applying.
//         </p>
//         <Link
//           to="/login"
//           className="inline-block px-4 py-2 rounded-xl bg-lime-400 text-black font-semibold"
//         >
//           Login / Register
//         </Link>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-xl mx-auto md:mt-14 bg-slate-800 p-6 rounded-2xl">
//       <h1 className="text-2xl font-bold mb-4">Apply as Agent</h1>

//       <div className="grid gap-4">
//         {/* Full name */}
//         <label className="block">
//           <div className="text-sm text-slate-300">Full name</div>
//           <input
//             className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white"
//             value={form.fullName}
//             onChange={onChange("fullName")}
//             placeholder="Your full legal name"
//           />
//         </label>

//         {/* Phone */}
//         <label className="block">
//           <div className="text-sm text-slate-300">Phone (mobile)</div>
//           <input
//             className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white"
//             placeholder="07X XXX XXXX"
//             value={form.phone}
//             onChange={onChange("phone")}
//           />
//           <div className="text-[11px] text-slate-400 mt-1">
//             We’ll store a normalized copy for user matching.
//           </div>
//         </label>

//         {/* Country */}
//         <label className="block">
//           <div className="text-sm text-slate-300">Country</div>
//           <select
//             className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white"
//             value={form.country}
//             onChange={onChange("country")}
//           >
//             <option value="" disabled>
//               Select country…
//             </option>
//             {COUNTRY_OPTIONS.map((c) => (
//               <option key={c} value={c}>
//                 {c}
//               </option>
//             ))}
//           </select>
//         </label>

//         {/* District (depends on country) */}
//         <label className="block">
//           <div className="text-sm text-slate-300">District / Region</div>
//           <select
//             className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white disabled:opacity-50"
//             value={form.district}
//             onChange={onChange("district")}
//             disabled={!form.country}
//           >
//             <option value="" disabled>
//               {form.country ? "Select district…" : "Select a country first"}
//             </option>
//             {districts.map((d) => (
//               <option key={d} value={d}>
//                 {d}
//               </option>
//             ))}
//           </select>
//         </label>

//         {/* Town / City */}
//         <label className="block">
//           <div className="text-sm text-slate-300">Town / City</div>
//           <input
//             className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white"
//             value={form.city}
//             onChange={onChange("city")}
//             placeholder="e.g., Dehiwala, Negombo, Kandy…"
//           />
//         </label>
//       </div>

//       <div className="mt-6 flex items-center gap-3">
//         <button
//           onClick={save}
//           disabled={loading}
//           className="px-4 py-2 rounded-xl bg-lime-400 text-black font-semibold disabled:opacity-50"
//         >
//           {loading ? "Saving…" : existing ? "Update" : "Submit"}
//         </button>
//         {existing?.status && (
//           <div className="text-sm text-slate-300">
//             Current status: <b className="capitalize">{existing.status}</b>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../../firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-hot-toast";
import { Phone, AlertTriangle } from "lucide-react";

/* ───────── helpers ───────── */
const sanitizeDigits = (v = "") => String(v || "").replace(/\D/g, "");

// Country catalog (extend anytime)
const COUNTRIES = [
  { code: "LK", name: "Sri Lanka", dial: "+94", min: 9, max: 10 },
  { code: "IN", name: "India", dial: "+91", min: 10, max: 10 },
  { code: "US", name: "United States", dial: "+1", min: 10, max: 10 },
  { code: "GB", name: "United Kingdom", dial: "+44", min: 9, max: 10 },
  { code: "AE", name: "United Arab Emirates", dial: "+971", min: 8, max: 9 },
  { code: "SG", name: "Singapore", dial: "+65", min: 8, max: 8 },
  { code: "AU", name: "Australia", dial: "+61", min: 9, max: 9 },
];

// District lists (trimmed)
const COUNTRY_DISTRICTS = {
  "Sri Lanka": [
    "Colombo",
    "Gampaha",
    "Kalutara",
    "Kandy",
    "Matale",
    "Nuwara Eliya",
    "Galle",
    "Matara",
    "Hambantota",
    "Jaffna",
    "Kilinochchi",
    "Mannar",
    "Vavuniya",
    "Mullaitivu",
    "Batticaloa",
    "Ampara",
    "Trincomalee",
    "Kurunegala",
    "Puttalam",
    "Anuradhapura",
    "Polonnaruwa",
    "Badulla",
    "Monaragala",
    "Ratnapura",
    "Kegalle",
  ],
  India: [
    "Andhra Pradesh",
    "Delhi",
    "Gujarat",
    "Karnataka",
    "Kerala",
    "Maharashtra",
    "Punjab",
    "Rajasthan",
    "Tamil Nadu",
    "Telangana",
    "Uttar Pradesh",
    "West Bengal",
  ],
  "United Arab Emirates": [
    "Abu Dhabi",
    "Dubai",
    "Sharjah",
    "Ajman",
    "Umm Al Quwain",
    "Ras Al Khaimah",
    "Fujairah",
  ],
  "United Kingdom": ["England", "Scotland", "Wales", "Northern Ireland"],
  "United States": [
    "Alabama",
    "California",
    "Florida",
    "New York",
    "Texas",
    "Washington",
  ],
};
const COUNTRY_OPTIONS = Object.keys(COUNTRY_DISTRICTS);

const findCountryByDial = (dial) =>
  COUNTRIES.find((c) => c.dial === dial) || COUNTRIES[0];
const findCountryByCode = (code) =>
  COUNTRIES.find((c) => c.code === code) || COUNTRIES[0];

const looksLikeGroupLink = (url = "") =>
  /whatsapp\.com|wa\.me|t\.me|telegram\.me/i.test(String(url).trim());

/* ───────── component ───────── */
export default function AgentApply({ user }) {
  const [form, setForm] = useState({
    fullName: "",
    country: "",
    district: "",
    city: "",
    communityLink: "",
  });

  // phone (profile-style)
  const [phoneCountry, setPhoneCountry] = useState("LK");
  const [phoneLocal, setPhoneLocal] = useState("");
  const dial = useMemo(
    () => COUNTRIES.find((c) => c.code === phoneCountry)?.dial || "+94",
    [phoneCountry]
  );
  const phoneE164 = useMemo(
    () => (phoneLocal ? `${dial}${sanitizeDigits(phoneLocal)}` : ""),
    [dial, phoneLocal]
  );

  const [loading, setLoading] = useState(false);
  const [existing, setExisting] = useState(null);

  // mandatory checkbox
  const [confirm50, setConfirm50] = useState(false);

  // computed helpers
  const districts = useMemo(
    () => (form.country ? COUNTRY_DISTRICTS[form.country] || [] : []),
    [form.country]
  );
  const meta = findCountryByCode(phoneCountry);
  const phoneOk = () => {
    const d = sanitizeDigits(phoneLocal);
    return d.length >= meta.min && d.length <= meta.max;
  };
  const groupOk = looksLikeGroupLink(form.communityLink);

  // prefill
  useEffect(() => {
    (async () => {
      if (!user?.uid) return;

      const snap = await getDoc(doc(db, "agents", user.uid));
      if (snap.exists()) {
        const d = snap.data();
        setExisting({ id: snap.id, ...d });

        const preCode =
          d.phoneCountryCode ||
          findCountryByDial(d.phoneCountryDial || d.phoneCountry || "+94").code;
        const preLocal =
          d.phoneLocal ||
          sanitizeDigits(
            (d.phoneE164 || d.phone || "").replace(d.phoneCountryDial || "", "")
          );

        setPhoneCountry(preCode || "LK");
        setPhoneLocal(preLocal || "");

        setForm((f) => ({
          ...f,
          fullName: d.fullName || f.fullName,
          country: d.country || f.country,
          district: d.district || f.district,
          city: d.city || d.town || f.city,
          communityLink: d.communityLink || "",
        }));
        setConfirm50(!!d.confirmGroup50Plus); // keep previous confirmation if saved
      } else {
        const u = await getDoc(doc(db, "users", user.uid));
        if (u.exists()) {
          const ud = u.data();
          const guessedDial = ud.phoneCountry || ud.phoneCountryDial || "+94";
          setPhoneCountry(findCountryByDial(guessedDial).code);
          const local = sanitizeDigits(
            (ud.phone || ud.userMobile || "").replace(guessedDial, "")
          );
          setPhoneLocal(local);
        }
      }
    })();
  }, [user?.uid]);

  const onChange = (k) => (e) => {
    const val = e.target.value;
    setForm((s) =>
      k === "country"
        ? { ...s, country: val, district: "" }
        : { ...s, [k]: val }
    );
  };

  const save = async () => {
    if (!user?.uid) return toast.error("Please login first");

    const fullName = (form.fullName || "").trim();
    const country = (form.country || "").trim();
    const district = (form.district || "").trim();
    const city = (form.city || "").trim();
    const communityLink = (form.communityLink || "").trim();

    if (!fullName || !country || !district || !city) {
      toast.error("Please fill all fields");
      return;
    }
    if (!phoneOk()) {
      toast.error(`Enter a valid mobile: ${meta.min}–${meta.max} digits`);
      return;
    }
    if (!communityLink) {
      toast.error("Community group link is required");
      return;
    }
    if (!groupOk) {
      toast.error("Enter a valid WhatsApp or Telegram group URL");
      return;
    }
    if (!confirm50) {
      toast.error("You must confirm the group has 50+ members");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        fullName,
        phoneE164,
        phoneLocal: sanitizeDigits(phoneLocal),
        phoneCountryCode: phoneCountry,
        phoneCountryDial: meta.dial,
        // legacy mirrors
        phone: phoneE164,
        mobile: sanitizeDigits(phoneLocal),

        country,
        district,
        city,

        communityLink,
        confirmGroup50Plus: true, // persisted flag

        status: existing?.status || "pending",
        cardFeePerCardUSD: existing?.cardFeePerCardUSD ?? 1,
        feeOutstandingUSD: existing?.feeOutstandingUSD ?? 0,
        feePendingUSD: existing?.feePendingUSD ?? 0,

        createdAt: existing?.createdAt || serverTimestamp(),
        updatedAt: serverTimestamp(),

        username:
          existing?.username ||
          user.displayName ||
          user.email ||
          user.uid.slice(0, 6),
        email: existing?.email || user.email || "",
        avatar: existing?.avatar || user.photoURL || "/user.png",
      };

      await setDoc(doc(db, "agents", user.uid), payload, { merge: true });
      toast.success(existing ? "Application updated" : "Application submitted");
      setExisting((e) => ({ ...(e || {}), ...payload }));
    } catch (e) {
      console.error(e);
      toast.error("Failed to save");
    } finally {
      setLoading(false);
    }
  };

  /* ───────── UI ───────── */
  if (!user?.uid) {
    return (
      <div className="max-w-xl mx-auto mt-10 bg-slate-800 p-6 rounded-2xl text-center">
        <h1 className="text-2xl font-bold mb-2">Apply as Agent</h1>
        <p className="text-slate-300 mb-4">
          You need to be signed in before applying.
        </p>
        <Link
          to="/login"
          className="inline-block px-4 py-2 rounded-xl bg-lime-400 text-black font-semibold"
        >
          Login / Register
        </Link>
      </div>
    );
  }

  const submitDisabled =
    loading ||
    !phoneOk() ||
    !looksLikeGroupLink(form.communityLink) ||
    !confirm50;

  return (
    <div className="max-w-xl mx-auto md:mt-14 bg-slate-800 p-6 rounded-2xl">
      {/* prominent requirement banner */}
      <div className="mb-4 p-3 rounded-xl bg-amber-500/15 ring-1 ring-amber-400/30 text-amber-200 flex items-start gap-2">
        <AlertTriangle className="w-5 h-5 mt-0.5" />
        <div className="text-sm">
          <b>Community group (50+ members) is mandatory.</b> Provide a public
          invite link to your WhatsApp or Telegram group. Applications without a
          valid group will be rejected.
        </div>
      </div>

      <h1 className="text-2xl font-bold mb-4">Apply as Agent</h1>

      <div className="grid gap-4">
        {/* Full name */}
        <label className="block">
          <div className="text-sm text-slate-300">Full name</div>
          <input
            className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white"
            value={form.fullName}
            onChange={onChange("fullName")}
            placeholder="Your full legal name"
          />
        </label>

        {/* Mobile Number */}
        <div className="p-4 bg-slate-900/50 rounded-xl space-y-3">
          <div className="flex items-center gap-2 text-white font-semibold">
            <Phone className="w-5 h-5 text-indigo-400" />
            Mobile Number
          </div>

          <div className="grid grid-cols-3 gap-2">
            <select
              className="col-span-1 px-3 py-2 rounded bg-slate-700 text-white"
              value={phoneCountry}
              onChange={(e) => setPhoneCountry(e.target.value)}
            >
              {COUNTRIES.map((c) => (
                <option key={c.code} value={c.code}>
                  {c.name} ({c.dial})
                </option>
              ))}
            </select>
            <input
              className="col-span-2 px-3 py-2 rounded bg-slate-700 text-white"
              placeholder={`Phone number (digits only, ${meta.min}–${meta.max})`}
              value={phoneLocal}
              onChange={(e) => setPhoneLocal(sanitizeDigits(e.target.value))}
            />
          </div>

          <div className="text-xs text-slate-400">
            We’ll store your number as{" "}
            <span className="font-mono">
              {meta.dial}
              {sanitizeDigits(phoneLocal)}
            </span>
            . This must be unique to your account.
          </div>
        </div>

        {/* Country */}
        <label className="block">
          <div className="text-sm text-slate-300">Country</div>
          <select
            className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white"
            value={form.country}
            onChange={onChange("country")}
          >
            <option value="" disabled>
              Select country…
            </option>
            {COUNTRY_OPTIONS.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </label>

        {/* District */}
        <label className="block">
          <div className="text-sm text-slate-300">District / Region</div>
          <select
            className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white disabled:opacity-50"
            value={form.district}
            onChange={onChange("district")}
            disabled={!form.country}
          >
            <option value="" disabled>
              {form.country ? "Select district…" : "Select a country first"}
            </option>
            {districts.map((d) => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </label>

        {/* City */}
        <label className="block">
          <div className="text-sm text-slate-300">Town / City</div>
          <input
            className="w-full mt-1 px-3 py-2 rounded bg-slate-700 text-white"
            value={form.city}
            onChange={onChange("city")}
            placeholder="e.g., Dehiwala, Negombo, Kandy…"
          />
        </label>

        {/* Community group link — REQUIRED */}
        <label className="block">
          <div className="flex items-center gap-2">
            <div className="text-sm text-slate-300">Community group link</div>
            <span className="text-[11px] px-2 py-0.5 rounded-full bg-red-500/20 text-red-300 ring-1 ring-red-400/30">
              Required • 50+ members
            </span>
          </div>
          <input
            className={`w-full mt-1 px-3 py-2 rounded text-white ring-1 ${
              !form.communityLink || groupOk
                ? "bg-slate-700 ring-slate-600"
                : "bg-red-900/30 ring-red-500/60"
            }`}
            placeholder="WhatsApp / Telegram group URL"
            value={form.communityLink}
            onChange={onChange("communityLink")}
          />
          <div
            className={`text-[11px] mt-1 ${
              !form.communityLink || groupOk ? "text-slate-400" : "text-red-300"
            }`}
          >
            Example: https://chat.whatsapp.com/… or https://t.me/your_group
          </div>

          <label className="mt-2 flex items-center gap-2 text-sm text-slate-200">
            <input
              type="checkbox"
              className="accent-lime-400"
              checked={confirm50}
              onChange={(e) => setConfirm50(e.target.checked)}
            />
            I confirm this group currently has{" "}
            <b className="ml-1">50+ members</b>.
          </label>
        </label>
      </div>

      <div className="mt-6 flex items-center gap-3">
        <button
          onClick={save}
          disabled={submitDisabled}
          className="px-4 py-2 rounded-xl bg-lime-400 text-black font-semibold disabled:opacity-50"
        >
          {loading ? "Saving…" : existing ? "Update" : "Submit"}
        </button>
        {existing?.status && (
          <div className="text-sm text-slate-300">
            Current status: <b className="capitalize">{existing.status}</b>
          </div>
        )}
      </div>
    </div>
  );
}
